import { Links, Meta, Scripts, ScrollRestoration, useRouteLoaderData } from "@remix-run/react";
import type * as React from "react";
import { ExternalScripts } from "remix-utils/external-scripts";

import type { loader } from "./root";

export default function Layout({ children: app }: { children: React.ReactNode }) {
  const data = useRouteLoaderData<typeof loader>("root");

  return (
    <html lang={data?.lang}>
      <head>
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
        />
        <Meta />
        <Links />
      </head>
      <body className="font-montserrat">
        {app}
        <ScrollRestoration />
        <ExternalScripts />
        <Scripts />
      </body>
    </html>
  );
}
